module.exports = __webpack_public_path__ + "static/media/Մարիետա-Բադալյան-Կոմիտաս-Լորիկ.7078571f.mp3";